export const PLUS_BUTTON_CLICK_DURATION = 0.2
export const CONTEXT_MENU_VISIBLE_ANIMATION_DURATION = 0.3
export const CONTEXT_MENU_STAY_VISIBLE_DURATION = 0.5
export const SOURCE_CLICK_DURATION = 0.2
export const CONTEXT_MENU_HIDE_ANIMATION_DURATION = 0.3
export const SEND_BUTTON_CLICK_DURATION = 0.2
export const CHAT_INPUT_HEIGHT_ANIMATION_DURATION = 0.3
export const MESSAGE_VISIBLE_ANIMATION_DURATION = 0.2
export const THINKING_STAY_VISIBLE_DURATION = 1
export const RESPONSE_VISIBLE_ANIMATION_DURATION = 1
export const RESPONSE_STAY_VISIBLE_DURATION = 0.5

export enum Stage {
  START = 'start',
  ADD_SOURCE = 'add-source',
  SOURCES_ADDED = 'sources-added',
  SEND = 'send',
  RESET = 'reset',
}
